import { CardExtension } from "./card-extension";
import { CardGroupExtension } from "./card-group-extension";
import { AdmonitionExtension } from "./admonition-extension";
import { StepsExtension } from "./steps-extension";
import { StepExtension } from "./step-extension";
import { ScreenshotExtension } from "./screenshot-extension";
import { TabsExtension } from "./tabs-extension";
import { TabExtension } from "./tab-extension";
import { AccordionGroupExtension } from "./accordion-group-extension";
import { AccordionExtension } from "./accordion-extension";
import { GlossaryExtension } from "./glossary-extension";
import { CitationExtension } from "./citation-extension";
import { FolderContentsExtension } from "./folder-contents-extension";
import { MermaidExtension } from "./mermaid-extension";
import { ToggleExtension } from "./toggle-extension";
import { AnyExtension } from "@tiptap/core";
import { InternalNoteExtension } from "./internal-note-extension";
import { QuotedSourcesExtension } from "./quoted-sources-extension";

export const CustomComponentsExtensions: AnyExtension[] = [
  CardGroupExtension,
  CardExtension,
  AdmonitionExtension,
  InternalNoteExtension,
  StepsExtension,
  StepExtension,
  ScreenshotExtension,
  TabsExtension,
  TabExtension,
  AccordionExtension,
  AccordionGroupExtension,
  GlossaryExtension,
  CitationExtension,
  FolderContentsExtension,
  MermaidExtension,
  ToggleExtension,
  QuotedSourcesExtension,
]
